<!--
  发票管理
  相关 JavaScript脚本在config/mixin文件中
 -->

<template>
	<div class="list">
    <list-head @searchEmit="search" placeholder="请输入发票编号进行搜索">
      <span slot="title">发票管理</span>
      <template slot="options" v-for="btn in topPermission">
        <el-button size="small" v-if="btn === 'add'" type="primary" @click="addnew">{{topMap[btn]}}</el-button>
        <el-button size="small" v-else @click="topBtnHandle(btn)">{{topMap[btn]}}</el-button>
      </template>
    </list-head>
    <div class="content">
      <list-panel ref="panel" :sortArray="sortArray" @ssChange="refreshTable" @refresh="getList" :belonger="belonger">
        <el-radio-group
          size="small" 
          slot="archive"
          v-model="cancel"
          class="custom-archived"
          @change="cancelChange">
          <el-radio-button :label="0">正常</el-radio-button>
          <el-radio-button :label="1">红冲</el-radio-button>
          <el-radio-button :label="2">已作废</el-radio-button>
        </el-radio-group>
      </list-panel>

      <list-table
        ref="table"
        :summaryInfo = "summaryInfo"
        :tableHead="listHead"
        :tableData="listData"
        :listMenu="hasListMenu"
        @details="openDetail"
        @edit="editItem"
        @refresh="getList"
        @addRedTicket="addRedTicket"
        @cancel="cancelHandle">
      </list-table>

      <div class="foot-wrapper">
        <list-footer
          ref="foot"
          :permission="botPermission"
          @deleteArr="deleteRows"
          @cancelCheck="cancelTableCheck"
          @archived="handlePerm">
          <!-- 发票批量操作 -->
          <template slot="permission"     slot-scope="props">
            <el-button
              size="small"
              @click="handlePerm(props.type)">
              <template v-if="props.type === 'cancel'">
                {{cancelText}}
              </template>
              <template v-else>{{props.text}}</template>
            </el-button>
          </template>
        </list-footer>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <transition name="slide">
      <detail
        ref="detail"
        v-if="detailShow"
        :id="detailId"
        :moduleName="popModel"
        @addNew="newWorkFlow"
        @close="closeDetail"
        @refresh="getList"
        @edit="editItem"
        @recall="handleRecall">
      </detail>
    </transition>
    <transition name="fade">
      <div class="detail-bg" v-if="detailShow" @click="detailShow=false"></div>
    </transition>
    <add-new
      ref="addNew"
      v-if="addnewShow"
      @closeDialog="addnewShow=false"
      @refresh="getList"
      @callback="callBack"
      :addnewProp="addnewProp">
    </add-new>

    <export v-if="exportShow" @export="exportFile" @closeDialog="closeExport"></export>
    <batch-edit v-if="batchEditShow" :selectIds="getSelectIds" @refresh="success" @closeDialog="batchEditShow = false"></batch-edit>
	</div>
</template>

<script>
import * as mixin from 'src/config/mixin'
import * as api from 'src/api'
import { Message, MessageBox } from 'element-ui'

export default {
  data () {
    return {
      cancel: 0,
      addRedTicketShow: false
    }
  },
  created () {
    this.initList('invoice')
    this.getList()
  },
  computed: {
    cancelText () {
      if (this.cancel) {
        return '还原'
      } else {
        return '作废'
      }
    }
  },
  mixins: [mixin.list],
  methods: {
    // 切换作废筛选
    cancelChange () {
      // 同步到vuex
      this.updateSelectrows({del: 'all'})
      this.getList()
    },

    // 作废确认
    cancelHandle (len, type, id) {
      //  跨月作废的确认
      let ids = id ? [id] : this.getSelectIds //  所有打算作废id
      let sureMsg = ''
      this.listData.forEach((item) => {
        ids.forEach((item1) => {
          if (item.id === item1 && item.crossMonth === true) {
            sureMsg = id ? '发票已经跨月,' : '包含跨月发票,'
            return
          }
        })
      })
      MessageBox.confirm(`${sureMsg}是否${this.cancelText}这${len}条发票信息吗?`, `${this.cancelText}确认`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cancelInvoice(type, id)
      }).catch(() => {})
    },

    callBack () {
      if (this.detailShow) {
        this.detailShow = false
      }
      this.getList()
    },

    // 作废&还原
    cancelInvoice (type, id) {
      let url = '/invoice/cancel.html'
      let isCancel = ''
      if (type === 'cancel') {
        isCancel = 1
      } else if (type === 'revertCancel') {
        isCancel = 0
      }
      let params = {
        id: id ? [id] : this.getSelectIds,
        isCancel: isCancel
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        // 同步到vuex
        this.updateSelectrows({del: 'all'})
        this.getList()
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// invoice.vue?79bfedb7